import React, { useMemo, useState } from 'react';
import styles from './index.module.less';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const FAQDataOut: React.FC<any> = ({ content }) => {
  const [selectIndex, setSelectIndex] = useState(0);
  const getTitle = useMemo(() => {
    return <div className={styles.title}>Frequently Asked Questions</div>;
  }, []);

  const getContent = () => {
    return (
      <div className={styles.content}>
        <h2 style={{ width: 0, height: 0, display: 'none' }}>Frequently Asked Questions</h2>

        {getTitle}

        <div className={styles.contentList}>
          {content?.content_list?.map((item: any, index: number) => (
            <div className={styles.contentItem} key={index}>
              <div
                className={classNames(styles.contentItemTitle)}
                onClick={() => {
                  if (index === selectIndex) {
                    setSelectIndex(-1);
                  } else {
                    setSelectIndex(index);
                  }
                }}
              >
                <h3 className={classNames([styles.subTitle, index === selectIndex && styles.selectedSubTitle])}>
                  <div dangerouslySetInnerHTML={{ __html: item.question }}></div>
                </h3>
                {index === selectIndex ? (
                  <UpOutlined style={{ fontSize: '12px' }} />
                ) : (
                  <DownOutlined style={{ fontSize: '12px' }} />
                )}
              </div>
              <div
                className={styles.subDesc}
                style={{ display: selectIndex === index ? 'block' : 'none' }}
                dangerouslySetInnerHTML={{ __html: item.answer }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return <>{getContent()}</>;
};

export default FAQDataOut;
